import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import Loading from "component/section/Loading";

import { sizes } from "asset/constant";
import { useSN } from "hook";

const GridView = <T,>({
  data,
  renderItem,
  gridHeight,
  showLoading,
  numberOfCol,
  spacing = sizes.space,
}: GridViewT<T>) => {
  const [containerWidth, setContainerWidth] = useState(null);

  const sn = useSN();

  const width = (containerWidth - spacing) / (numberOfCol ?? 3);
  const height = gridHeight ?? width;

  return (
    <View
      style={{ ...styles.container, padding: spacing / 2 - sn(0, 0, 1, 1) }}
      onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
    >
      {!containerWidth ? (
        <View style={styles.loadingContainer}>
          {showLoading && <Loading />}
        </View>
      ) : (
        data.map((item, key) => (
          <View
            key={String(key)}
            style={{ padding: spacing / 2, width, height }}
          >
            {renderItem && renderItem(item)}
          </View>
        ))
      )}
    </View>
  );
};

export default GridView;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    flexWrap: "wrap",
    flexDirection: "row-reverse",
  },

  loadingContainer: {
    height: 100,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});
